import { render, staticRenderFns } from "./GlobalProductOptionsPopupIframe.vue?vue&type=template&id=10c1a76b&"
import script from "./GlobalProductOptionsPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./GlobalProductOptionsPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports